/**
 * 工作室图标映射配置
 * 将工作室名称映射到对应的 SVG 图标
 */

import Miniclip from '@/pages/dashboard/assets/svg/sth/miniclip.png';
import Fatshark from '@/pages/dashboard/assets/svg/sth/fatshark.png';
import Funcom from '@/pages/dashboard/assets/svg/sth/funcom.png';
import GGG from '@/pages/dashboard/assets/svg/sth/ggg.png';
import Inflexion from '@/pages/dashboard/assets/svg/sth/inflexion.png';
import Lighthouse from '@/pages/dashboard/assets/svg/sth/lighthouse.png';
import MNE from '@/pages/dashboard/assets/svg/sth/mne.png';
import Mundfish from '@/pages/dashboard/assets/svg/sth/mundfish.png';
import Platinum from '@/pages/dashboard/assets/svg/sth/platinum.png';
import Sharkmob from '@/pages/dashboard/assets/svg/sth/sharkmob.png';
import Shiftup from '@/pages/dashboard/assets/svg/sth/shiftup.png';
import Stunlock from '@/pages/dashboard/assets/svg/sth/stunlock.png';
import Sumo from '@/pages/dashboard/assets/svg/sth/sumo.png';
import Techland from '@/pages/dashboard/assets/svg/sth/techland.png';
import TurtleRock from '@/pages/dashboard/assets/svg/sth/turtle-rock.png';
import Yager from '@/pages/dashboard/assets/svg/sth/yager.png';
import Yongxing from '@/pages/dashboard/assets/svg/sth/yongxing.png';
import TenC from '@/pages/dashboard/assets/svg/sth/10c.png';
import ArrowHead from '@/pages/dashboard/assets/svg/sth/arrowhead.png';
import JoyWorkshop from '@/pages/dashboard/assets/svg/sth/joy-workshop.png';
import Crytek from '@/pages/dashboard/assets/svg/sth/crytek.png';

export const STUDIO_ICON_MAP: Record<string, string> = {
  Miniclip,
  Fatshark,
  Funcom,
  GGG,
  Inflexion,
  Lighthouse,
  DE: MNE,
  Mundfish,
  Platinum,
  Sharkmob,
  Shiftup,
  Stunlock,
  Sumo,
  Techland,
  'Turtle Rock': TurtleRock,
  Yager,
  Yongxing,
  '10C': TenC,
  MC: Miniclip,
  TR: TurtleRock,
  TL: Techland,
  Arrowhead: ArrowHead,
  'Joy Workshop': JoyWorkshop,
  JoyWorkshop,
  Crytek,
};

export const SPECIAL_STUDIO_NAME: {
  [key: string]: string;
} = {
  'Joy Workshop': 'JoyWorkshop',
};
